import type { JSX } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './Home.css';

type ActionItem = Readonly<{
  readonly label: string;
  readonly icon: string;
  readonly path: string;
  readonly variant: 'primary' | 'secondary';
}>;

type InfoLink = Readonly<{
  readonly label: string;
  readonly path: string;
}>;

const ACTIONS: ReadonlyArray<ActionItem> = [
  { label: 'Send', icon: '↑', path: '/send', variant: 'secondary' },
  { label: 'Request', icon: '↓', path: '/request', variant: 'secondary' },
  { label: 'Scan', icon: '⎚', path: '/scan', variant: 'primary' },
] as const;

const INFO_LINKS: ReadonlyArray<InfoLink> = [
  { label: 'How It Works', path: '/info/how-it-works' },
  { label: 'What are Handles?', path: '/info/handles' },
  { label: 'Fees', path: '/info/fees' },
] as const;

export const Home = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <div className="home">
      <section className="home-hero">
        <p className="home-subtitle">Fast retail crypto payments</p>
        <nav className="home-info-links" aria-label="Learn more">
          {INFO_LINKS.map((link, i) => (
            <span key={link.path}>
              <Link to={link.path} className="home-info-link">{link.label}</Link>
              {i < INFO_LINKS.length - 1 && <span className="home-info-sep" aria-hidden="true"> · </span>}
            </span>
          ))}
        </nav>
      </section>

      <section className="home-actions" aria-label="Quick actions">
        {ACTIONS.map((action) => (
          <button
            key={action.path}
            className={`action-card action-card--${action.variant}`}
            onClick={() => navigate(action.path)}
            type="button"
          >
            <span className="action-icon">{action.icon}</span>
            <span className="action-label">{action.label}</span>
          </button>
        ))}
      </section>
    </div>
  );
};
